<template>
  <LayoutPage v-if="!isDashboard" class="px-0" title="Manage Tasks">
    <PageManageTasks
      :is-dashboard="isDashboard"
      @task-updated="handleTaskUpdate"
    />
  </LayoutPage>
  <PageManageTaskDashboard
    v-else
    :color="color"
    :overdue-count="overdueCount"
    @task-updated="handleTaskUpdate"
  />
</template>

<script>
import LayoutPage from "@layout/LayoutPage.vue";
import PageManageTasks from "./PageManageTasks.vue";
import PageManageTaskDashboard from "./PageManageTaskDashboard.vue";

export default {
  name: "TaskPageSwitch",
  components: {
    LayoutPage,
    PageManageTasks,
    PageManageTaskDashboard,
  },
  props: {
    color: {
      type: String,
      default: "rgb(105,189,217)",
    },
    overdueCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const isDashboard = window.location.href.includes("overdue");
    return {
      isDashboard,
    };
  },
  methods: {
    handleTaskUpdate(updateData) {
      this.$emit("refetch-tasks");
    },
  },
};
</script>
